import { createSlice, Slice } from '@reduxjs/toolkit';

/**
 * Cria um fragmento de estado prefixado.
 * @param {string} prefix
 */
function createBooleanSlice(prefix: string): Slice<
  boolean,
  {
    beTrue: () => boolean;
    beFalse: () => boolean;
    toggle: (state: boolean) => boolean;
  }> {
  return createSlice({
    name: prefix,
    initialState: false as boolean,
    reducers: {
      beTrue: (): boolean => true,
      beFalse: (): boolean => false,
      toggle: (state: boolean): boolean => !state,
    },
  });
}

export default createBooleanSlice;
